import {LocationInfo} from "@flowmaps-com/flowmaps-typescriptmodels";
import {LocationRankingName} from "../../dashboard/dashboard.types";
import {RefdataUtils} from "../../refdata/refdata-utils";

const LOCATION_RANKING_NAME_STORAGE_PREFIX = 'flowmaps.locationRankingName';

export function locationRankingNameStorageKey(userId?: string): string {
    return `${LOCATION_RANKING_NAME_STORAGE_PREFIX}.${userId || 'anonymous'}`;
}

export function loadLocationRankingNamePreference(storage: Storage, userId?: string): LocationRankingName | null {
    try {
        const value = storage.getItem(locationRankingNameStorageKey(userId)) as LocationRankingName;
        return Object.values(LocationRankingName).includes(value) ? value : null;
    } catch {
        return null;
    }
}

export function saveLocationRankingNamePreference(storage: Storage, selectedName: LocationRankingName,
                                                  userId?: string): void {
    try {
        storage.setItem(locationRankingNameStorageKey(userId), selectedName);
    } catch {
        // The ranking remains usable when browser storage is unavailable.
    }
}

export function locationRankingLabel(info: LocationInfo, selectedName: LocationRankingName): string {
    if (!info) return '';
    const address = RefdataUtils.addressFormatter(info.address, false).trim();
    const name = (info.name || '').trim();
    const object = [info.buildingCode, info.objectNumber]
        .map(value => (value || '').trim())
        .filter(value => !!value)
        .join(' - ');

    switch (selectedName) {
        case LocationRankingName.Name:
            return name || object || address;
        case LocationRankingName.Object:
            return object || name || address;
        case LocationRankingName.Address:
        default:
            return address || name || object;
    }
}
